/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Ayi Regiarty
*/

import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import Toast from 'react-native-toast-message';
import { View, StyleSheet, ScrollView, Dimensions } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import ItemDetail from '@components/global/ItemDetail';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import Input from '@components/form/Input';
import DatePicker from '@components/form/DatePicker';
// import SelectBox from '@components/form/SelectBox';
import * as Layout from '@components/screen/Layout';
import FileInput from '@components/form/FileInput';
import AttachmentsInput from '@components/form/AttachmentsInput';
import { isWeb, isMobileWeb, isAndroid } from '@global/screens';
import { getFileNameFromUrl } from '@global/helpers';
import { showPopup } from '@/store/modal';
// import { BOOLEAN_STATUS } from '@/constants';
import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
// import { MsB2b } from '@api/ms-b2b';
// import { MsAccount } from '@api/ms-account';

// const FormValidationSchema = Yup.object().shape({
//   delivery_order: Yup.object().required('delivery order is required.'),
//   sales_order: Yup.object().required('sales order is required.'),
//   customer_name: Yup.string().required('customer code is required.'),
//   channel: Yup.object().required('channel is required.'),
//   sales_team: Yup.object().required('sales team is required.'),
//   carrier: Yup.string().required('carrier is required.'),
//   pick_up_date: Yup.string().required('pick up date is required.'),
//   lpb: Yup.object().required('lpb number is required.'),
//   shipping_date: Yup.string().required('shipping date is required.'),
//   received_date: Yup.string().required('received date is required.'),
//   notes: Yup.string().required('notes is required.'),
//   delivery_order_file: Yup.string().required(
//     'delivery order file is required.',
//   ),
//   proforma_invoice_file: Yup.string().required('proforma is required.'),
//   goods_receive_file: Yup.string().required('goods receive is required.'),
// });

const dimension = Dimensions.get('screen');

const LPBFormScreen = (props) => {
  const dispatch = useDispatch();
  const formRef = useRef();

  const [detailData, setDetailData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isReady, setIsReady] = useState(false);
  // Delivery Order and Proforma Invoice are optional for Vietnam GRNs (same rule as the
  // detail screen's submit gate). Uses the record's own country, not the app's current one.
  const isVnLpb = (detailData?.is_active_for || []).includes('b2b_vn');

  const get3plLpbDetail = useApi(MsOrder.get3plLpbDetail);

  const getDetail = async (id) => {
    const response = await get3plLpbDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;

      setDetailData(result);
      setIsReady(true);
    }
  };

  const submitForm = async (payload) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      let finalPayload = {
        pick_up_date: payload.pick_up_date,
        shipping_date: payload.shipping_date,
        recieved_date: payload.received_date,
        lpb_number: payload.lpb,
        notes: payload.notes,
        status: payload.status,
      };

      if (payload.delivery_order_file) {
        finalPayload.delivery_order_url = payload.delivery_order_file;
      }
      if (payload.proforma_invoice_file) {
        finalPayload.performa_invoice = payload.proforma_invoice_file;
      }
      if (payload.goods_receive_file) {
        finalPayload.goods_recieved = payload.goods_receive_file;
      }
      if (payload.other_files?.length) {
        finalPayload.others_attachments = payload.other_files;
      }

      // Filter out null, undefined, and empty string values
      finalPayload = Object.fromEntries(
        Object.entries(finalPayload).filter(
          ([key, value]) =>
            value !== null && value !== undefined && value !== '',
        ),
      );

      if (!isEdit) {
        const createData = await MsOrder.create3plLpb(finalPayload);
        if (createData?.data?.data) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Successfully added data',
            type: 'success',
          });
          props.navigation.navigate('LPBDetailScreen', {
            id: createData?.data?.data?._id,
            name: createData?.data?.data?.customer_name,
            // titleScreen: createData?.data?.data?.reference_code,
          });
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'A system error occurred',
            type: 'error',
          });
        }
      } else {
        const updateData = await MsOrder.update3plLpb(
          detailData._id,
          finalPayload,
        );

        if (payload.status == 'need_approval') {
          await MsOrder.changeStatus3plLpb(detailData._id, payload.status, {});
        }
        if (updateData?.data?.data) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'Successfully edited data',
            type: 'success',
          });
          props.navigation.navigate('LPBDetailScreen', {
            id: updateData?.data?.data?._id,
            name: updateData?.data?.data?.customer_name,
            // titleScreen: updateData?.data?.data?.reference_code,
          });
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({
            text1: 'A system error occurred',
            type: 'error',
          });
        }
      }
      dispatch(showPopup({ name: 'isLoading', value: false }));
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  const goBack = () => {
    props.navigation.replace('LPBFormScreen', {});
    props.navigation.navigate('LPBScreen');
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setIsEdit(false);
      // setIsTableChanged(false);
      setDetailData({});
      setIsReady(false);
      if (props?.route?.params?.id) {
        setIsEdit(true);
        getDetail(props.route.params.id);
      } else {
        setTimeout(() => {
          setIsReady(true);
        }, 500);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {(isEdit && get3plLpbDetail?.loading) || !isReady ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : (isEdit ? detailData && Object.keys(detailData).length : true) ? (
        <Formik
          innerRef={formRef}
          initialValues={{
            pick_up_date:
              isEdit && detailData?.pick_up_date ? detailData.pick_up_date : '',
            lpb: isEdit && detailData?.lpb_number ? detailData.lpb_number : '',
            shipping_date:
              isEdit && detailData?.shipping_date
                ? detailData.shipping_date
                : '',
            received_date:
              isEdit && detailData?.recieved_date
                ? detailData.recieved_date
                : '',
            notes: isEdit && detailData?.notes ? detailData.notes : '',
            delivery_order_file:
              isEdit && detailData?.delivery_order_url
                ? detailData.delivery_order_url
                : '',
            proforma_invoice_file:
              isEdit && detailData?.performa_invoice
                ? detailData.performa_invoice
                : '',
            goods_receive_file:
              isEdit && detailData?.goods_recieved
                ? detailData.goods_recieved
                : '',
            other_files:
              isEdit && detailData?.others?.length ? detailData.others : [],
          }}
          // validationSchema={FormValidationSchema}
          onSubmit={async (payload) => submitForm(payload)}>
          {({
            setFieldValue,
            validateForm,
            handleSubmit,
            errors,
            touched,
            values,
          }) => (
            <>
              {isWeb ? (
                <Layout.Wrapper white={false}>
                  <Layout.Back title="GRN" onCallback={() => goBack()} />
                  <Layout.Title title={`${isEdit ? `Edit` : `Add`} GRN`}>
                    <View style={styles.row}>
                      <Button
                        type="primary"
                        rounded
                        buttonStyle={{ width: 120 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{
                              fontSize: 14,
                              letterSpacing: 0.5,
                              color: Colors.white,
                            }}>
                            {isEdit ? 'SAVE' : 'Save Draft'}
                          </SociollaText>
                        }
                        onPress={(evt) => {
                          setFieldValue('status', 'draft');
                          handleSubmit(evt);
                        }}
                      />
                    </View>
                  </Layout.Title>
                </Layout.Wrapper>
              ) : (
                false
              )}
              <Layout.Wrapper rounded>
                <ScrollView
                  style={isMobileWeb ? { height: dimension.height - 85 } : {}}
                  contentContainerStyle={{ width: '100%' }}>
                  <Layout.FormWrapper
                    style={{
                      paddingHorizontal: 15,
                      paddingTop: 20,
                      ...(isWeb
                        ? {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingHorizontal: 20,
                            marginBottom: 15,
                          }
                        : {
                            paddingBottom: !isMobileWeb
                              ? isAndroid
                                ? 200
                                : 150
                              : 320,
                          }),
                    }}>
                    <View style={styles.rowForm}>
                      <Layout.FormGroup>
                        <ItemDetail
                          name="DO Number"
                          value={
                            detailData.do_number ? detailData.do_number : '-'
                          }
                          withoutBorder
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <ItemDetail
                          name="Sales Order Number"
                          value={
                            detailData.so_number ? detailData.so_number : '-'
                          }
                          withoutBorder
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <ItemDetail
                          name="Customer Name"
                          value={
                            detailData.customer_name
                              ? detailData.customer_name
                              : '-'
                          }
                          withoutBorder
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <ItemDetail
                          name="Market Type"
                          value={detailData.channel ? detailData.channel : '-'}
                          withoutBorder
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <ItemDetail
                          name="Sales Team"
                          value={
                            detailData.sale_team ? detailData.sale_team : '-'
                          }
                          withoutBorder
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <ItemDetail
                          name="City"
                          value={
                            detailData?.delivery_address?.city?.name
                              ? detailData?.delivery_address?.city?.name
                              : '-'
                          }
                          withoutBorder
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <ItemDetail
                          name="Carrier"
                          value={
                            detailData.carrier_name !== 'false'
                              ? detailData.carrier_name
                              : '-'
                          }
                          withoutBorder
                        />
                      </Layout.FormGroup>
                      <View
                        style={{
                          borderBottomWidth: 1,
                          borderBottomColor: Colors.grey9,
                          marginBottom: 20,
                          marginTop: 0,
                          height: 1,
                        }}
                      />
                      <Layout.FormGroup>
                        <View style={{ width: '100%', flexDirection: 'row' }}>
                          <DatePicker
                            label="Pick Up Date"
                            name="pick_up_date"
                            style={{
                              marginRight: isWeb ? 10 : 0,
                              width: '100%',
                            }}
                            isRequired
                            value={
                              values.pick_up_date
                                ? values.pick_up_date
                                : // : editFormData.pick_up_date
                                  // ? editFormData.pick_up_date
                                  ''
                            }
                            disableBeforeDate={
                              new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
                            }
                            hasError={
                              errors.pick_up_date && touched.pick_up_date
                                ? errors.pick_up_date
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue('pick_up_date', value);
                            }}
                          />
                        </View>
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <Input
                          label="GRN Number"
                          value={
                            values.lpb
                              ? values.lpb
                              : // : editFormData.lpb
                                // ? editFormData.lpb
                                ''
                          }
                          isRequired
                          placeholder="GRN Number"
                          hasError={
                            errors.lpb && touched.lpb ? errors.lpb : null
                          }
                          onChangeText={(value) => {
                            setFieldValue('lpb', value);
                          }}
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <View style={{ width: '100%', flexDirection: 'row' }}>
                          <DatePicker
                            label="Shipping Date"
                            name="shipping_date"
                            style={{
                              marginRight: isWeb ? 10 : 0,
                              width: '100%',
                            }}
                            isRequired
                            value={
                              values.shipping_date
                                ? values.shipping_date
                                : // : editFormData.shipping_date
                                  // ? editFormData.shipping_date
                                  ''
                            }
                            disableBeforeDate={
                              new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
                            }
                            hasError={
                              errors.shipping_date && touched.shipping_date
                                ? errors.shipping_date
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue('shipping_date', value);
                            }}
                          />
                        </View>
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <View style={{ width: '100%', flexDirection: 'row' }}>
                          <DatePicker
                            label="Received Date"
                            name="received_date"
                            style={{
                              marginRight: isWeb ? 10 : 0,
                              width: '100%',
                            }}
                            isRequired
                            value={
                              values.received_date
                                ? values.received_date
                                : // : editFormData.received_date
                                  // ? editFormData.received_date
                                  ''
                            }
                            disableBeforeDate={
                              new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
                            }
                            hasError={
                              errors.received_date && touched.received_date
                                ? errors.received_date
                                : null
                            }
                            onChange={(value) => {
                              setFieldValue('received_date', value);
                            }}
                          />
                        </View>
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <Input
                          label="Notes"
                          value={
                            values.notes
                              ? values.notes
                              : // : editFormData.notes
                                // ? editFormData.notes
                                ''
                          }
                          placeholder="Notes"
                          hasError={
                            errors.notes && touched.notes ? errors.notes : null
                          }
                          onChangeText={(value) => {
                            setFieldValue('notes', value);
                          }}
                        />
                      </Layout.FormGroup>
                    </View>
                    <View style={styles.rowForm}>
                      <Layout.FormGroup>
                        <FileInput
                          confirmRemove
                          label="Delivery Order"
                          value={
                            values.delivery_order_file
                              ? getFileNameFromUrl(
                                  values.delivery_order_file,
                                  'Delivery-order',
                                )
                              : // : editFormData.delivery_order_file
                                // ? editFormData.delivery_order_file
                                ''
                          }
                          isRequired={!isVnLpb}
                          onChange={(value) => {
                            if (!value && detailData) {
                              MsOrder.delete3plLpbDocument(
                                detailData.id,
                                'delivery_order_url',
                              );
                            }
                            setFieldValue('delivery_order_file', value);
                          }}
                          containerStyleExtra={styles.uploadForm}
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        <FileInput
                          confirmRemove
                          label="Proforma Invoice"
                          value={
                            values.proforma_invoice_file
                              ? getFileNameFromUrl(
                                  values.proforma_invoice_file,
                                  'Proforma-invoice',
                                )
                              : // : editFormData.proforma_invoice_file
                                // ? editFormData.proforma_invoice_file
                                ''
                          }
                          isRequired={!isVnLpb}
                          onChange={(value) => {
                            if (!value && detailData) {
                              MsOrder.delete3plLpbDocument(
                                detailData.id,
                                'performa_invoice',
                              );
                            }
                            setFieldValue('proforma_invoice_file', value);
                          }}
                          containerStyleExtra={styles.uploadForm}
                        />
                      </Layout.FormGroup>
                      <Layout.FormGroup>
                        {detailData?.channel?.toLowerCase() == 'mt' ? (
                          <FileInput
                            confirmRemove
                            label="Goods Receive"
                            value={
                              values.goods_receive_file
                                ? getFileNameFromUrl(
                                    values.goods_receive_file,
                                    'Goods.receive',
                                  )
                                : // : editFormData.goods_receive_file
                                  // ? editFormData.goods_receive_file
                                  ''
                            }
                            isRequired
                            onChange={(value) => {
                              setFieldValue('goods_receive_file', value);
                            }}
                            containerStyleExtra={styles.uploadForm}
                          />
                        ) : (
                          false
                        )}
                      </Layout.FormGroup>
                      <View
                        style={{
                          borderBottomWidth: 1,
                          borderBottomColor: Colors.grey9,
                          marginVertical: 20,
                          height: 1,
                        }}
                      />
                      <Layout.FormGroup>
                        <AttachmentsInput
                          testID="lpb-form-other-files"
                          label="Other Files"
                          value={values.other_files}
                          onChange={(updatedAttachments) =>
                            setFieldValue('other_files', updatedAttachments)
                          }
                        />
                      </Layout.FormGroup>
                    </View>
                  </Layout.FormWrapper>
                </ScrollView>
              </Layout.Wrapper>
              {!isWeb && (isEdit ? !get3plLpbDetail?.loading : true) ? (
                <Layout.ButtonSticky
                  show={props?.route?.name == 'LPBFormScreen'}
                  route={props?.route}
                  buttons={[
                    {
                      title: 'Save Draft',
                      type: 'primary',
                      onPress: (evt) => {
                        setFieldValue('status', 'draft');
                        validateForm().then(() => {
                          handleSubmit(evt);
                        });
                      },
                    },
                  ]}
                />
              ) : (
                false
              )}
            </>
          )}
        </Formik>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: 'row' },
  rowForm: { width: isWeb ? 'calc(50% - 20px)' : '100%' },
  uploadForm: {
    borderRadius: 4,
    borderWidth: 1,
    height: isWeb ? 35 : 45,
    paddingHorizontal: 16,
    borderColor: Colors.grey0,
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export default LPBFormScreen;
